import React, { Component } from 'react';
import {Modal,Toast} from "antd-mobile";
import axios from "axios";
import storage from "../model/storage";
import MkTopic from "./MkTopic";
import "../assects/css/home.css";
import globalSubscribe from "../common/globalState";
const alert = Modal.alert;

class MkSelf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examId:"",
      paperId:"",
      userId:"",
      isDid:false,
      isShow:false,
      imgSrc:"",
      answerArrSelf:[],
      dataDid:0
    };
    this.SubExam=debounce(this.SubExam, 1000);
    this.sub=debounce(this.sub, 1000);
  }
  componentWillMount(){
    if(this.props.location.state&&this.props.location.state.examId){
      
    }else{
      this.props.history.replace(`/?examId=${storage.get("examId")}&paperId=${storage.get("paperId")}&market=${storage.get("market")}`);
      window.location.reload();
    }
    document.title="评分_主观题_山香教育";
    
  }
  componentDidMount(){
    
    let that = this;
   
   
      
      axios.get(storage.baseUrl+'/showPaper', {
        params: {
          examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
        }
      })
        .then(function (response) {
          // handle success
          //console.log(response.data);
          let questionDatas=response.data.questionDatas;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDatas
          })
         
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
       
    }
  
  
  
    
  

  componentDidUpdate(){
   
  }
  
  onRef = (ref) => {

    this.child = ref

}
  subCard=(questionId,optChoose,correctness,score,questionType)=>{
    if(this.props.location.state&&this.props.location.state.isDid===true){
      return false;
    }else{
      var that = this;
      // axios.get(storage.baseUrl+'/upAnswerCard', {
      //   params: {
      //     paperId: that.props.location.state.paperId,
      //     questionId: questionId,
      //     userId:that.props.location.state.userId,
      //     optChoose:optChoose,
      //     correctness:correctness,
      //     score:score
      //   }
      // })
      //   .then(function (response) {
         
      //  //console.log(response);
         
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })
      const { answerArrSelf = [] } = this.state;

      let obj = {}
      obj = {
        paperId: that.props.location.state.paperId,
        questionId: questionId,
        userId:that.props.location.state.userId,
        optChoose:optChoose,
        correctness:correctness,
        score:score,
        questionType:questionType
      }
      const index = answerArrSelf.findIndex(o => o.questionId == obj.questionId);
      let answerArrSelfNew = [...answerArrSelf]
      if(index > -1) {
        answerArrSelfNew[index] = obj;
      }else {
        answerArrSelfNew.push(obj);
      }
      // console.log(answerArrSelfNew,'answerArrSelfNew')
      this.setState({ answerArrSelf: answerArrSelfNew})
    }
    
  }
  onClose =() => {
    this.setState({
     imgShow: false
    });
  }
 imgShow=(e)=>{
  //console.log(e);
  if(e.target.nodeName==="IMG"){
    this.setState({
      imgShow:true,
      imgSrc:e.target.src
    })
  }
 }
 
 showAlert = () => {
  alert('评分提示', '自评得分已完成，是否再检查一下？', [
    { text: '检查评分', onPress: () => console.log('cancel'), style: 'default' },
    { text: '确定提交', onPress: () =>  this.SubExam()},
  ]);

};
NoCshow = () => {
  alert('评分提示', '您还有题目未评分，确定提交吗？', [
    { text: '继续评分', onPress: () => console.log('cancel'), style: 'default' },
    { text: '确定提交', onPress: () => this.SubExam()},
  ]);

};
 sub = () => {
  var that = this;
  // console.log(that.state.answerArrSelf,'that.state.answerArrSelf')
  // axios.get(storage.baseUrl + '/checkPaperReviewDegrees', {
  //   params: {
  //     examId: that.props.location.state.examId,
  //     paperId: that.props.location.state.paperId,
  //     userId: that.props.location.state.userId
  //   }
  // })
  axios({
    method:'post',
    headers: {
      'Content-Type': 'application/json',
    },
    url:storage.baseUrl + '/upAnswerCard', 
    data:that.state.answerArrSelf
  })
    .then(function (response) {
      if (response.data.code === "0000") {
        // let dataDid = 0
        // for(let i=0;i<that.state.answerArrSelf.length;i++){
        //   if(that.state.answerArrSelf[i].score!==""){
        //     dataDid++;
        //   }
        // }
        // that.setState({
        //   dataDid:dataDid
        // })
        // console.log(that.state.dataDid,'that.state.dataDid',that.state.answerArrSelf.length);
        // that.state.dataDid<that.state.answerArrSelf.length?that.NoCshow():that.showAlert()
        that.checkExam()
      } else {
        Toast.info(response.msg);
      }

    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })



}
checkExam = () =>{
  var that = this;
  axios.get(storage.baseUrl + '/checkPaperReviewDegrees', {
    params: {
      examId: that.props.location.state.examId,
      paperId: that.props.location.state.paperId,
      userId: that.props.location.state.userId
    }
  }).then(function (response) {
    if (response.data.code !== "0000") {  
      that.NoCshow()
    } else {
      that.showAlert()
    }
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  })
}
SubExam = (type) => {
    
  var that = this;
  let time=storage.get("time");
  axios.get(storage.baseUrl + '/referToPaper', {
    params: {
      examId: that.props.location.state.examId,
      paperId: that.props.location.state.paperId,
      userId: that.props.location.state.userId,
      usringTime:time
    }
  // axios({
  //   method:'post',
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  //   url:storage.baseUrl + '/referToPaper?examId='+that.props.location.state.examId+"&paperId="+that.props.location.state.paperId+"&userId="+that.props.location.state.userId+"&usringTime="+time, 
  //   data:{answerCardList:[],answerCardList2:this.state.answerArrSelf}
  })
    .then(function (response) {
      //console.log(response);
      if(response.data.code==="0000"){
        Toast.info('交卷成功', 1);
        that.props.history.push({ pathname: "/Result", state: {examType:"1", examId: that.props.location.state.examId, paperId: that.props.location.state.paperId, userId: that.props.location.state.userId } });

        
      }
     

    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })

}
  render() {
   
    return (
      <div>
          <Modal
          className="imgCon"
            visible={this.state.imgShow}
            transparent
            maskClosable={true}
            onClose={this.onClose}
            title="查看图片"
            footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose();} }]}
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            
          >
          <img style={{width:'100%'}} src={this.state.imgSrc} alt="" />
          </Modal>
      <div className="self_btn" onClick={this.sub}>确定</div>
      <div className="gf_con" >
          
         <div className="qus_con">
           {
             this.state.questionDates&&this.state.questionDates.map((value,key)=>{
               if(value.questionType==="1001"){
                
               }else if(value.questionType==="1002"){
               
              }else if(value.questionType==="1003"){
               
              }
              else if(value.questionType==="1013"){
               
              }else if(value.questionType==="1016"){
               
              }
              else{
                return(
                  <MkTopic data={[value]} isSelf={true}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='辨析题' listXX="综合"></MkTopic>
               
                )
              }
             })
           }
        {/* <Completion data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='填空题' listXX="题型"></Completion>
         
           <Multi data={this.state.multiList}  subCard={this.subCard} imgShow={this.imgShow} title='多项选择题' listXX="题型"></Multi>
          <Single data={this.state.judgeList}  subCard={this.subCard} imgShow={this.imgShow} title='判断题' isDan="1" listXX="题型"></Single>
          <Topic data={this.state.shortList}  subCard={this.subCard} imgShow={this.imgShow} title='简答题' listXX="题型"></Topic>
          <Topic data={this.state.analysList} subCard={this.subCard} imgShow={this.imgShow} title='辨析题' listXX="题型"></Topic>
          <Topic data={this.state.materAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='材料分析题' listXX="题型"></Topic>
          <Topic data={this.state.writings}  subCard={this.subCard} imgShow={this.imgShow} title='写作题' listXX="题型"></Topic>
          <Topic data={this.state.desingns}  subCard={this.subCard} imgShow={this.imgShow} title='教学设计题' listXX="题型"></Topic>
          <Topic data={this.state.caseAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='案例分析题' listXX="题型"></Topic>
          <Topic data={this.state.nounExplains}  subCard={this.subCard} imgShow={this.imgShow} title='名词解释题' listXX="题型"></Topic>
          <Topic data={this.state.discussTypes}  subCard={this.subCard} imgShow={this.imgShow} title='论述题' listXX="题型"></Topic>
          <Topic data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='活动设计题' listXX="题型"></Topic> */}
        
          </div>
      
      </div>
      </div>
    );
          
  }
}
function debounce(fn, ms) {
  let timeoutId
  return function () {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn.apply(this, arguments)
    }, ms)
  }
}
export default MkSelf;
